import script from "./HeaderNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNavigation.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNavigation.vue?vue&type=style&index=0&id=4bdceae0&lang=scss"

const __exports__ = script;

export default __exports__